module.exports = fox._r("images/player_banner.png", __webpack_public_path__ + "_/_/_/root/images/player_banner.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/player_banner.png
// module id = 30
// module chunks = 4